import { gql } from '@apollo/client';
import { MenuFragment } from './Menu';

export const VENUE_FRAGMENT = gql`
  fragment VenueFragment on Venue {
    name
    hashedId
    timezone
    posName
    operatingHours {
      status
      daysOfWeek
      dates {
        day
        month
        year
      }
      time {
        from
        to
      }
      appId
      menuId
    }
  }
`;

export const VenueDataQuery = gql`
  query VenueDataQuery($locationId: ID!) {
    menus(locationId: $locationId) {
      ...MenuFragment
    }
  }

  ${MenuFragment}
`;

export const SupportedAppsQuery = gql`
  query SupportedApps {
    supportedApps {
      id
      image
      name
    }
  }
`;

export const UPDATE_BUSY_MODE_MUTATION = gql`
  mutation UpdateSubscriptionBusyMode($locationId: String!, $appId: String!, $busyUntil: String, $brandId: String) {
    updateSubscriptionBusyMode(locationId: $locationId, appId: $appId, busyUntil: $busyUntil, brandId: $brandId)
  }
`;

export const UPDATE_OPERATING_HOURS_MUTATION = gql`
  mutation UpdateOperatingHours($locationId: ID!, $operatingHours: [OperatingHoursInput!]!) {
    updateOperatingHours(locationId: $locationId, operatingHours: $operatingHours) {
      operatingHours {
        status
        daysOfWeek
        dates {
          day
          month
          year
        }
        time {
          from
          to
        }
        appId
        menuId
      }
    }
  }
`;

export const BOOST_YEARLY_REVENUE = gql`
  query BoostYearlyRevenue($locationId: ID!) {
    boostYearlyRevenue(locationId: $locationId)
  }
`;

export const BOOST_PEAK_AVERAGE_REVENUE_PERIODS = gql`
  query BoostPeakAverageRevenuePeriods($locationId: ID!) {
    boostPeakAverageRevenuePeriods(locationId: $locationId) {
      venueHashedId
      dayOfWeek
      averageTotalNumberOfOrders
      averageTotalRevenueOrders
      periodFrom
      periodTo
    }
  }
`;

export const BOOST_LOW_AVERAGE_REVENUE_PERIODS = gql`
  query BoostLowAverageRevenuePeriods($locationId: ID!) {
    boostLowAverageRevenuePeriods(locationId: $locationId) {
      venueHashedId
      dayOfWeek
      averageTotalNumberOfOrders
      averageTotalRevenueOrders
      periodFrom
      periodTo
    }
  }
`;
